<template>
  <b-modal
    v-model="modal"
    centered
    content-class="shadow border-0"
    size="lg"
    footer-class="justify-content-start"
    header-border-variant="0"
    @hide="afterModalHide"
    footer-border-variant="0"
  >
    <template #modal-title>
      <p class="lead text-blue-500 font-weight-bold mb-0 px-3">
        <b-icon-alarm class="mr-2" scale="1.3"></b-icon-alarm>
        {{ $t('childPage.modalChildrenChosen.title') }}
      </p>
    </template>
    <template #default>
      <p class="mb-0 text-base text-blue-500 px-3">
        {{ $t('childPage.modalChildrenChosen.description') }}
      </p>
    </template>
    <template #modal-footer>
      <b-button class="button-width mx-3" variant="primary" @click="routerPushHome">
        {{ $t('childPage.modalChildrenChosen.button') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalChildrenChosen',
  props: {
    isChildChosen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modal: false
    }
  },
  methods: {
    afterModalHide() {
      this.routerPushHome()
    },
    routerPushHome() {
      this.$router.push({ name: 'Home' })
    }
  },
  created() {
    this.modal = this.isChildChosen
  }
}
</script>
